<template>
  <form @submit.prevent="submitForm()">
    <form-field
      v-model="form.email"
      :errors="errors.email"
      :disabled="busy"
      label="Email"
      type="email"
    />
    <form-field
      v-model="form.password"
      :errors="errors.password"
      :disabled="busy"
      label="Password"
      type="password"
    />
    <div class="flex flex-col mb-6">
      <label for="remember">
        <input
          id="remember"
          v-model="form.remember"
          :disabled="busy"
          type="checkbox"
        />
        Remember me
      </label>
    </div>
    <button
      class="button"
      type="submit"
      :disabled="busy"
      v-text="busy ? 'Logging in...' : 'Log In'"
    />
    <nuxt-link
      to="/forgot-password"
      class="ml-4 text-gray-500 hover:text-gray-600"
    >
      Forgot password?
    </nuxt-link>
  </form>
</template>

<script>
import FormField from '~/components/FormField.vue'

export default {
  components: {
    FormField
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        remember: false
      },
      errors: {},
      busy: false
    }
  },
  methods: {
    submitForm() {
      this.errors = {}
      this.busy = true
      this.$axios.$get('/sanctum/csrf-cookie').then(() => {
        this.$auth
          .loginWith('local', {
            data: this.form
          })
          .then(() => {
            this.$emit('loggedIn')
            this.$notify({
              title: 'Logged In',
              text: 'Welcome back!'
            })
          })
          .catch((error) => {
            this.busy = false
            if (error.response.status === 401) {
              this.errors = { password: ['Email or password is incorrect.'] }
            }
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
          })
      })
    }
  }
}
</script>
